import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo:{}
  },
  getters:{
    getUserInfo: state => state.userInfo,
  },
  mutations: {
    ['User_Info'](state, payload) {
      console.log('payload',payload)
      state.userInfo = payload
    },
  },
  actions: {
    setUserInfo({ commit, state }, payload) {
      commit('User_Info', payload)
    },
  }
})

